import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { AiOutlineClose } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import axios from 'axios';
import { URL } from '../../AxiosUrlGlobal';
import styles from './TicketViewModal.module.css';

function TicketViewModal({ ticket, onClose }) {
  const [status, setStatus] = useState(ticket.status);
  const [priority, setPriority] = useState(ticket.priority);
  const [adminNotes, setAdminNotes] = useState(ticket.adminNotes || '');
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${URL}admin/support-ticket`,
        {
          ticketId: ticket._id,
          status,
          priority,
          adminNotes
        },
        {
          headers: { token }
        }
      );

      if (response.data.success) {
        toast.success('Ticket updated successfully');
        onClose();
      } else {
        toast.error(response.data.error || 'Failed to update ticket');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to update ticket');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this ticket?')) {
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(
        `${URL}admin/support-ticket/${ticket._id}`,
        {
          headers: { token }
        }
      );

      if (response.data.success) {
        toast.success('Ticket deleted successfully');
        onClose();
      } else {
        toast.error(response.data.error || 'Failed to delete ticket');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete ticket');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Support Ticket Details</h2>
          <button className={styles.closeIcon} onClick={onClose}>
            <AiOutlineClose />
          </button>
        </div>

        <div className={styles.modalBody}>
          {/* User Information */}
          <div className={styles.section}>
            <h3>{ticket.isGuest ? 'Guest User' : 'User Information'}</h3>
            <div className={styles.infoGrid}>
              {!ticket.isGuest && (
                <>
                  <div className={styles.infoItem}>
                    <label>Username:</label>
                    <span>{ticket.user?.username || 'N/A'}</span>
                  </div>
                  <div className={styles.infoItem}>
                    <label>Store Name:</label>
                    <span>{ticket.user?.StoreName || 'N/A'}</span>
                  </div>
                  <div className={styles.infoItem}>
                    <label>Email:</label>
                    <span>{ticket.user?.email || 'N/A'}</span>
                  </div>
                  <div className={styles.infoItem}>
                    <label>User Mobile:</label>
                    <span>{ticket.user?.mobile || 'N/A'}</span>
                  </div>
                </>
              )}
              {ticket.isGuest && (
                <div className={styles.infoItem}>
                  <label>User Type:</label>
                  <span style={{ color: '#6b7280', fontStyle: 'italic' }}>Guest User (Not Registered)</span>
                </div>
              )}
            </div>
          </div>

          {/* Ticket Information */}
          <div className={styles.section}>
            <h3>Ticket Information</h3>
            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <label>Contact Name:</label>
                <span>{ticket.name}</span>
              </div>
              <div className={styles.infoItem}>
                <label>Contact Mobile:</label>
                <span>{ticket.mobile}</span>
              </div>
              <div className={styles.infoItem}>
                <label>Created:</label>
                <span>{new Date(ticket.createdAt).toLocaleString()}</span>
              </div>
              <div className={styles.infoItem}>
                <label>Last Updated:</label>
                <span>{new Date(ticket.updatedAt).toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Message */}
          <div className={styles.section}>
            <h3>Message</h3>
            <div className={styles.messageBox}>
              {ticket.message}
            </div>
          </div>

          {/* Admin Actions */}
          <div className={styles.section}>
            <h3>Admin Actions</h3>

            <div className={styles.formGroup}>
              <label>Status</label>
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="pending">Pending</option>
                <option value="in_progress">In Progress</option>
                <option value="resolved">Resolved</option>
                <option value="closed">Closed</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label>Priority</label>
              <select value={priority} onChange={(e) => setPriority(e.target.value)}>
                <option value="low">Low</option>
                <option value="normal">Normal</option>
                <option value="high">High</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label>Admin Notes (Internal)</label>
              <textarea
                value={adminNotes}
                onChange={(e) => setAdminNotes(e.target.value)}
                rows="4"
                placeholder="Add internal notes about this ticket..."
              />
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            className={styles.deleteButton}
            onClick={handleDelete}
            disabled={loading}
          >
            <MdDelete /> Delete Ticket
          </button>
          <div className={styles.actionButtons}>
            <button
              className={styles.cancelButton}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={styles.updateButton}
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Update Ticket'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TicketViewModal;
